// src/services/api.js

import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://stelonne-market.online/backend/public/api';


// Instance axios
const api = axios.create({
  baseURL: API_URL,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  },
  withCredentials: true,
});

// Intercepteur pour ajouter le token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('auth_token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error)
  }
);

// Intercepteur pour les erreurs
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      localStorage.removeItem('auth_token');
      localStorage.removeItem('user');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

// ============================================
// AUTHENTIFICATION
// ============================================

export const authAPI = {

  // Récupère le cookie CSRF (nécessaire avant login)
  getCsrfCookie: async () => {
    return await api.get('/sanctum/csrf-cookie');
  },

  register: async (userdata) => {
    console.log('Donnee en cours d\'envoie', userdata)
    const response = await api.post('/auth/register', {
      name: userdata.name,
      email: userdata.email,
      phone: userdata.phone,
      password: userdata.password,
      password_confirmation: userdata.password_confirmation,
      role_id: userdata.role_id,
    })
    if (response.data.success) {
      //localStorage.setItem('auth_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    console.log('reponse de l\'enregistrement', response)
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    if (response.data.success) {
      localStorage.setItem('auth_token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  profile: async() => {
    try{
      const response = await api.get('/me');
      return response.data;
    } catch (error) {
      if (error.response?.status === 401) {
        localStorage.removeItem('auth_token');
        localStorage.removeItem('user');
      }
      throw error;
    }
  },

  logout: async() => {
    const response = await api.post('/auth/logout');
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    return response.data;
  },
};

export const userAPI = {
  // Récupérer tous les utilisateurs avec leurs rôles
  getAll: async () => {
    try {
      const response = await api.get('/users');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Récupérer tous les rôles
  getRoles: async () => {
    try {
      const response = await api.get('/roles');
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Mettre à jour un utilisateur
  update: async (userId, userData) => {
    try {
      const response = await api.put(`/users/${userId}`, userData);
      return response;
    } catch (error) {
      throw error;
    }
  },

  // Supprimer un utilisateur
  delete: async (userId) => {
    try {
      const response = await api.delete(`/users/${userId}`);
      return response;
    } catch (error) {
      throw error;
    }
  }
};

// ============================================
// PRODUITS
// ============================================

export const productAPI = {
  getAll: async (params = {}) => {
    try {
      const response = await api.get('/products', { params });
      console.log('📦 API Response structure:', {
        status: response.status,
        data: response.data,
        isArray: Array.isArray(response.data),
        hasDataKey: response.data && response.data.data !== undefined
      });
      
      // Retournez directement les données
      return response.data;
    } catch (error) {
      console.error('❌ Erreur dans productAPI.getAll:', error);
      throw error;
    }
  },

  // Nouvelle: Récupérer les infos de base
  getBasicInfo: async (id) => {
      try {
          const response = await api.get(`/products/${id}/basic`);
          return response.data;
      } catch (error) {
          console.error('Erreur getBasicInfo:', error);
          throw error;
      }
  },
  
  // Nouvelle: Récupérer les images
  getProductImages: async (id) => {
      try {
          const response = await api.get(`/products/${id}/images`);
          return response.data;
      } catch (error) {
          console.error('Erreur getProductImages:', error);
          throw error;
      }
  },
  
  getByCategory: async(categoryId) => {
    const response = await api.get(`/categories/${categoryId}/products`);
    return response;
  },
  // getByCategory: (categoryId) => api.get(`/produits/categorie/${categoryId}`),
  
  getById: async (id) => {
    console.log('📦 package envoye vers le serveur pour le produit dont l\'id', id);
    const response = await api.get(`/products/${id}`);
    console.log('📦 package du produit recu avec succes', response.data);
    return response.data;
  },

  create: async (formData) => {
    console.log('📦 Données reçues pour création produit:', formData);

    try{

    
      const formattedData = new FormData();
      
      // Champs obligatoires selon votre backend Laravel
      formattedData.append('name', formData.name.trim());
      formattedData.append('description', formData.description || '');
      formattedData.append('price', parseFloat(formData.price));
      formattedData.append('quantity', parseInt(formData.quantity));
      formattedData.append('category_id', parseInt(formData.category_id));
      
      // Fournisseurs - CORRECTION IMPORTANTE
      if (formData.supplier_ids && formData.supplier_ids.length > 0) {
        // Pour Laravel, il faut ajouter chaque ID séparément
        formData.supplier_ids.forEach(supplierId => {
          formattedData.append('supplier_ids[]', supplierId);
        });
      }
      
      // Gestion des images multiples - CORRECTION
      if (formData.images && formData.images.length > 0) {
        formData.images.forEach((image, index) => {

          if (image.file) {
            // Nouvelle image : fichier
            formattedData.append(`images[${index}][image]`, image.file);
            formattedData.append(`images[${index}][alt_text]`, image.alt_text || '');
            formattedData.append(`images[${index}][is_primary]`, image.is_primary ? '1' : '0');
          }
        });
      }

      // DEBUG : Affichez ce qui est dans FormData
      console.log('📦 FormData envoyé:');
      for (let [key, value] of formattedData.entries()) {
        console.log(`${key}:`, value);
      }
      
      const response = await api.post('/products_new', formattedData, {
        headers: { 
          'Content-Type': 'multipart/form-data',
          'Accept': 'application/json'
        },
      });

      console.log('✅ Réponse API:', response.data);
      return response;

    } catch (error){
      console.error('❌ Erreur API détaillée:', {
        message: error.message,
        response: error.response?.data,
        status: error.response?.status,
        config: error.config
      });
      throw error;
    }
  },


  update: async (id, productData) => {  // productData est un objet JS, pas FormData
    try {
      const formattedData = new FormData();
      
      console.log('🔄 Raw data received in update:', productData);
      
      // CORRECTION CRITIQUE : Ajoutez TOUS les champs
      formattedData.append('name', productData.name || '');
      formattedData.append('description', productData.description || '');
      formattedData.append('price', String(productData.price || 0));
      formattedData.append('quantity', String(productData.quantity || 0));
      formattedData.append('category_id', String(productData.category_id || ''));
      
      // Fournisseurs
      if (productData.supplier_ids && productData.supplier_ids.length > 0) {
        productData.supplier_ids.forEach(supplierId => {
          formattedData.append('supplier_ids[]', String(supplierId));
        });
      } else {
        // Même vide, envoyez quelque chose
        formattedData.append('supplier_ids[]', '');
      }
      
      // Chargement des Images existantes (avec ID)
      if (productData.images && productData.images.length > 0) {
        productData.images.forEach((image, index) => {
          if (image.id) {
            formattedData.append(`images[${index}][id]`, String(image.id));
            formattedData.append(`images[${index}][alt_text]`, image.alt_text || '');
            formattedData.append(`images[${index}][is_primary]`, image.is_primary ? '1' : '0');
          } 
        });
      }

      // DEBUG : Vérifiez ce qui est dans FormData
      console.log('📤 FormData contents:');
      for (let [key, value] of formattedData.entries()) {
        console.log(`${key}:`, value instanceof File ? `File: ${value.name}` : value);
      }


      // Gestion des nouvelles images (sans ID)
      
      const newImages = productData.images.filter(img => img.file);
      if (newImages && newImages.length > 0) {
        productData.images.forEach(async (image, index) => {
          if (image.file) {
            const imageFormData = new FormData();

            imageFormData.append(`image`, image.file);
            imageFormData.append(`alt_text`, image.alt_text || '');
            imageFormData.append(`is_primary`, image.is_primary ? '1' : '0');
          
            const img = await api.post(`/products_image/${id}`, imageFormData, {
              headers: { 
                'Content-Type': 'multipart/form-data', 
                'Accept': 'application/json'}
            });
            console.log('✅ Nouvelles images uploadées');
          }
        });
      }

      const response = await api.put(`/products/${id}`, formattedData);

      console.log('✅ Réponse API:', response.data);
      return response;

    } catch (error) {
      console.error('❌ Update error:', error.response?.data || error.message);
      throw error;
    }
  },


  delete: async (id) => {
    const response = await api.delete(`/products/${id}`)
    return response;
  },

  // MÉTHODE 2: Récupérer les produits par catégorie (ou tous si categoryId = 'all' ou null)
  // Récupérer les produits par catégorie avec pagination
  getProductsOptimizedByCategory: async (categoryId, page = 1, perPage = 50) => {
    try {
        const url = categoryId === 'all' 
            ? '/by-category/all' 
            : `/by-category/${categoryId}`;
        const response = await api.get(url, {
            params: { page, per_page: perPage }
        });
        console.log('📦 API Response structure:', {
        status: response.status,
        data: response.data,
        isArray: Array.isArray(response.data),
        hasDataKey: response.data && response.data.data !== undefined
      });
        return response.data;
    } catch (error) {
        console.error('Erreur getProductsOptimizedByCategory:', error);
        throw error;
    }
  },

  
  // Recherche avec pagination
  searchProductsAdvanced: async (searchTerm, page = 1, perPage = 50) => {
    try {
        const response = await api.get('/search/optimized', {
            params: { q: searchTerm, page, per_page: perPage }
        });
        console.log('📦 API Response structure:', {
        status: response.status,
        data: response.data,
        isArray: Array.isArray(response.data),
        hasDataKey: response.data && response.data.data !== undefined
      });
        return response.data;
    } catch (error) {
        console.error('Erreur searchProductsAdvanced:', error);
        throw error;
    }
  }
};

// ============================================
// Image
// ============================================

export const imageAPI = {
  getImage: async (fileName) => {
    const response = await api.get(`/products/image/${fileName}`)
    return response;
  }
};

// ============================================
// PANIER
// ============================================

export const cartAPI = {
  getCart: async () => {
    try {
      const response = await api.get('/cart');
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  addToCart: async (cartData) => {
    try {
      console.log('📦 Données envoyées pour ajout au panier:', cartData);
      const response = await api.post('/cart_add', cartData);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  updateCart: async (updateCart, quantity) => {
    try {
      console.log('📦 Données envoyées pour mise à jour du panier:', updateCart,'nouvelle quantite', quantity);
      const response = await api.put(`/cart/${quantity}`, updateCart);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  removeFromCart: async (productremove) => {
    try {
      console.log('📦 Données envoyées pour suppression du produit du panier:', productremove);
      const response = await api.delete(`/cart_product?user_id=${productremove.user_id}&product_id=${productremove.product_id}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  clearCart: async (userId) => {
    try {
      const response = await api.delete(`/cart/clear`, {
        data: { userId }
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};

// ============================================
// CATÉGORIES
// ============================================

export const categoryAPI = {
  getAll: async() => {
    const response = await api.get('/categories');
    return response; 
  },

  // MÉTHODE 1: Récupérer les catégories (id et name uniquement)
  getCategoriesList: async () => {
    try {
        console.log("envoie de la demande de reception de liste")
        const response = await api.get('/categories/list');
        console.log("📦 Réponse API pour getCategoriesList:", response);
        return response.data;
    } catch (error) {
        console.error('Erreur getCategoriesList:', error);
        throw error;
    }
  },

  getCategoryIdByName: async (categoryName) => {
    try {
        const response = await api.get('/categories/by-name', {
            params: { name: categoryName }
        });
        return response.data;
    } catch (error) {
        console.error('Erreur getCategoryIdByName:', error);
        throw error;
    }
  },

  getUniqueAll: async() => {
    const response = await api.get('/categories/all');
    return response; 
  },

  getById: async (id) => {
    const response = await api.get(`/categories/${id}`);
    return response;
  },
  
  create: async(data) => {
    const response = await api.post('/categories', {
      name: data.name,
      description: data.description || ''
    });
    return response;
  },

  update: async (id, updata) => {
    const response = await api.put(`/categories/${id}`, {
      name: updata.name,
      description: updata.description || ''
    });
    return response;
  },
  
  delete: async(id) => { 
    const response = await api.delete(`/categories/${id}`);
    return response; 
  },
};

// ============================================
// FOURNISSEURS
// ============================================

export const supplierAPI = {
  getAll: async() => {
    const response = await api.get('/suppliers'); 
    return response;
  },

  getAllSupplier: async() => {
    const response = await api.get('/suppliers/all'); 
    return response;
  },

  getById: async(id) => {
    console.log('📦 package envoye vers le serveur');
    const response = await api.get(`/suppliers/${id}`);
    return response;
  },

  // Nouvelle: Récupérer les fournisseurs
  getProductSuppliers: async (id) => {
    try {
        
        const response = await api.get(`/suppliers/${id}/suppliers`);
        
        return response.data;
    } catch (error) {
        console.error('Erreur getProductSuppliers:', error);
        throw error;
    }
  },
  
  create: async(data) => {
    console.log('📦 Données reçues pour création d\'un fournisseur:', data);
    
    const response = await api.post('/suppliers', {
      name: data.name,
      email: data.email || '',
      phone: data.phone,
      address: data.address,
      city: data.city,
      country: data.country
    });

    console.log('✅ Réponse API:', response.data);
    return response;
  },

  update: async(id, data) => {
    const response = await api.put(`/suppliers/${id}`, {
      name: data.name,
      email: data.email || '',
      phone: data.phone,
      address: data.address,
      city: data.city,
      country: data.country
    });
    return response;
  },
  
  delete: async(id) => {
    const response = await api.delete(`/suppliers/${id}`);
    return response;
  },
};

// ============================================
// COMMANDES
// ============================================

export const orderAPI = {
  // orders = commandes
  create: async (data) => {
    console.log('processus de chargement de la commande')
    const response = await api.post('/orders', {
      user_id: data.user_id,
      recipient_name: data.recipient_name,
      recipient_email: data.recipient_email,
      recipient_phone: data.recipient_phone,
      recipient_address: data.recipient_address,
      recipient_city: data.recipient_city,
      recipient_country: data.recipient_country,
      status: data.status || 'pending',
      total_amount: data.total_amount,
      notes: data.notes || "",
      items: data.products,
    });
    return response;
  },

  // getMyOrders: async () => {
  //   const response = await api.get('/orders/my-orders');
  //   return response.data;
  // },

  getMyOrders: async (id) => {
    const response = await api.get(`/orders/${id}`);
    return response;
  },
  
  getAll: async () => {
    const response = await api.get('/orders');
    return response;
  },
  
  // updateStatus: async(id, statut) => {
  //   const response = await api.put(`/orders/${id}/statut`, { statut });
  //   return response;
  // },

  updateStatMont: async (id, data) => {
    const response = await api.put(`/orders/${id}`, { 
      status: data.status.toLowerCase().replace(' ', '_'),
      total_amount: data.total_amount  
    });
    return response;
  },

  deleteorders: async(id) => {
    const response = await api.delete(`/orders/${id}`);
    return response;
  },

  getStats: async () => {
    const response = await api.get('/orders/stats');
    return response;
  }
};

export { API_URL };

export default api;